import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import unlockTherapistService from 'src/services/apiServices/unlockTherapist/unlockTherapistService';
import { unlockTherapistConstant } from '../../actions/constant';

const {
  GET_LOCK_DAILY_SESSION_NOTES_REQUEST,
  GET_LOCK_DAILY_SESSION_NOTES_SUCCESS,
  GET_LOCK_DAILY_SESSION_NOTES_FAILURE,
  GET_LOCK_DAILY_SESSION_NOTES_RESET,
  GET_LOCK_DAILY_SESSION_NOTES_LOADING,
} = unlockTherapistConstant;

function* getLockDailySessionNote(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_LOCK_DAILY_SESSION_NOTES_LOADING });

    const response = yield call(unlockTherapistService.getLockDailySessionNote, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_LOCK_DAILY_SESSION_NOTES_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_LOCK_DAILY_SESSION_NOTES_FAILURE, payload: error });
  }
}

function* getLockDailySessionNoteSaga() {
  yield takeEvery(GET_LOCK_DAILY_SESSION_NOTES_REQUEST, getLockDailySessionNote);
}

export default getLockDailySessionNoteSaga;
